import type { AccuracyErrorItem, SavedAccuracyReport } from '../types/accuracy';
import type { AccuracyGuidelineChatContext } from './accuracyGuidelineChat';
import type { MetricCountDrilldown } from './accuracyCountDrilldown';

function pickDrilldownFromErrors(errors: AccuracyErrorItem[]): MetricCountDrilldown {
  const fp = errors.filter((e) => e.error === 'fp');
  const fn = errors.filter((e) => e.error === 'fn');
  const pool = fp.length >= fn.length ? fp : fn;
  const sample = pool[0] ?? errors[0];
  const countKind =
    sample?.error === 'fn'
      ? 'fn'
      : sample?.error === 'fp'
        ? 'fp'
        : sample?.error === 'wrong_bounding_box'
          ? 'wb'
          : 'tp';

  return {
    categoryId: sample?.category_id ?? null,
    categoryName: sample?.category_name ?? '全体',
    metricType: sample?.type ?? 'existence',
    countKind,
  };
}

export function buildTuningDraftChatContext(params: {
  report: SavedAccuracyReport;
  errors: AccuracyErrorItem[];
  errorSourceLabel: string;
}): AccuracyGuidelineChatContext {
  const { report, errors, errorSourceLabel } = params;
  return {
    reportId: report.id,
    reportName: report.name,
    guidelineVersion: report.filters.guideline_version ?? 0,
    drilldown: pickDrilldownFromErrors(errors),
    totalItemCount: errors.length,
    urlCount: report.result?.url_count ?? 0,
    sampleErrors: errors.slice(0, 30),
    errorSourceLabel,
  };
}
